export default {
	data() {
		return {
			visibleActive: false
		};
	},
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		delay: {
			type: Number,
			default: 500
		}
	},
	watch: {
		visible: {
			immediate: true,
			handler(value) {
				if (this.delay > 0) {
					setTimeout(() => {
						this.visibleActive = value;
					}, this.delay);
				} else {
					this.visibleActive = value;
				}
			}
		}
	}
};
